import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import GoalStaticsDetailContainer from '../../containers/goal_statics/GoalStaticsDetailContainer';

const GoalStaticsViewDetailPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="경영정보/사업목표/상세정보" icon="statistics" />
      <GoalStaticsDetailContainer />
    </div>
  );
};

export default GoalStaticsViewDetailPage;
